import React, { useEffect, useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import Cookies from "js-cookie";
import { getBackendBaseUrl } from "../../utils/envUtils";

export default function ScheduleControlButton() {
  const HOST = getBackendBaseUrl();
  const SCHEDULE_CONTROL = `${HOST}/api/v1/upsell-schedule/control`;
  const token = Cookies.get("jwtToken");

  const [enabled, setEnabled] = useState(null); // null = unknown, true/false = state
  const [loading, setLoading] = useState(false);

  // Load current state on mount
  useEffect(() => {
    let mounted = true;
    async function fetchState() {
      try {
        setLoading(true);
        const res = await fetch(SCHEDULE_CONTROL, {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });
        if (!res.ok) throw new Error("Failed to fetch schedule control state");
        const data = await res.json();
        if (mounted) setEnabled(Boolean(data.enabled));
      } catch (err) {
        console.error(err);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    fetchState();
    return () => {
      mounted = false;
    };
  }, [SCHEDULE_CONTROL, token]);

  const toggle = async () => {
    try {
      setLoading(true);
      const res = await fetch(SCHEDULE_CONTROL, {
        method: "POST", // or PUT if that’s what your backend expects
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ enabled: !enabled }),
      });
      if (!res.ok) throw new Error("Failed to toggle schedule control");
      const data = await res.json();
      setEnabled(Boolean(data.enabled));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Loading state button
  if (loading) {
    return (
      <Button
        variant="contained"
        disabled
        sx={{
          maxWidth: "200px",
        }}
        startIcon={<CircularProgress size={16} />}
      >
        Loading…
      </Button>
    );
  }

  // Disabled until first fetch completes
  if (enabled === null) {
    return (
      <Button
        variant="contained"
        sx={{
          maxWidth: "200px",
        }}
        disabled
      >
        Loading state…
      </Button>
    );
  }

  return (
    <div
      sx={{
        maxWidth: "200px",
      }}
    >
      <Button
        variant="contained"
        color={enabled ? "success" : "error"}
        disabled={loading}
        onClick={toggle}
        sx={{
          width: "auto",
          whiteSpace: "nowrap",
          textTransform: "none",
          maxWidth: "200px",
        }}
      >
        {loading
          ? "Loading..."
          : enabled
          ? "Enabled – Click to Disable"
          : "Disabled – Click to Enable"}

        {/* Invisible span keeps width stable */}
        <span style={{ visibility: "hidden", position: "absolute" }}>
          Enabled – Click to Disable
        </span>
      </Button>
    </div>
  );
}
